import axios from 'axios';
import toSnakeCaseThenStringify from '@/helpers/toSnakeCaseThenStringify';
import {
    SENTIMENT_WIDGET_CHART_DATA_KEY,
    SENTIMENT_WIDGET_CHARTS_DATA_KEY,
    SENTIMENT_WIDGET_COUNTERS_DATA_KEY
} from '@/assets/dashboard/cache-keys';

export const state = () => ({});

export const getters = {
    SENTIMENT_WIDGET_CHART_DATA_KEY: () => SENTIMENT_WIDGET_CHART_DATA_KEY,
    SENTIMENT_WIDGET_CHARTS_DATA_KEY: () => SENTIMENT_WIDGET_CHARTS_DATA_KEY,
    SENTIMENT_WIDGET_COUNTERS_DATA_KEY: () => SENTIMENT_WIDGET_COUNTERS_DATA_KEY
};

export const mutations = {};

export const actions = {
    index(vuexContext, { range, accountId, interval, timeZone, properties }) {
        const params = {
            range,
            timeZone,
            interval,
            accountId,
            properties: toSnakeCaseThenStringify(properties)
        };

        return axios.getMethodOverridePost('/v1/dashboard/sentiment', { params, encodeURI: true });
    },

    comparedIndex(vuexContext, { range, accountId, timeZone, arrayOfProperties, interval }) {
        const params = {
            range,
            interval,
            timeZone,
            accountId,
            properties: arrayOfProperties
        };

        return axios.getMethodOverridePost('/v1/dashboard/compared_sentiment', {
            params
        });
    }
};
